import { createTheme } from "@mui/material";

export const getMuiTheme = (theme: any) => createTheme({
    palette: {
        primary: {
            main: theme.text.contrast5
        }
    }
  });